import React, { useCallback } from 'react'
import { Button, Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    width: ({ width }: propTypes) => width,
    marginTop: ({ mt }: propTypes) => mt,
    marginBottom: ({ mb }: propTypes) => mb,
    padding: ({ padding }: propTypes) => padding || '14px 45px',

    borderRadius: 4,
    border: '1px solid rgba(255,255,255,0.6)',

    fontSize: 14,
    lineHeight: 0,
    fontWeight: 500,
    textTransform: 'none',

    color: theme.palette.primary.light,
    background: 'transparent',
    opacity: '0.87',
    '&:hover': {
      color: theme.palette.primary.light,
      backgroundColor: theme.palette.info.main,
      border: `1px solid ${theme.palette.secondary.main}`,
    },
  },
  text: {
    textTransform: 'none',
  },
}))

type propTypes = {
  width: number | string
  text: string
  mt?: number | string
  mb?: number | string
  padding?: string
  type?: string
  href?: string
  onClick?: () => void
}

export const TransparentButton: React.FC<propTypes> = ({ text, width, mt, mb, padding, type, href, onClick }) => {
  const classes = useStyles({ width, mt, mb, padding, type, href, text })
  const history = useHistory()

  const goTo = useCallback(() => {
    history.push(`${href}`)
  }, [history, href])

  return (
    <Button variant="contained" onClick={href ? goTo : onClick} className={classes.button}>
      <span className={classes.text}>{text}</span>
    </Button>
  )
}
